import pagesNames from "../../../constants/pages-names";

const governancePageData = {
    mainTitle: "Governance",
    borderSection: {
        title: "Overarching goal",
        subtitle: "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making.",
    },
    paragraphOne: "SAB operates from a strong foundation of value-creating governance. We believe that a robust approach to corporate governance is key to the sustainability of the Bank. Consequently, SAB adopts the highest standards of good governance. We have a track record of positive achievements including diversity - our Board brings a mixture of local and international experts from a wide spectrum of industries. ",
    paragraphTwo: "In terms of gender diversity achievement, SAB is in the upper quartiles of organisations in the region. Our Executive Management team currently includes 5 females, and 22% of all our employees are women. SAB provides ongoing training and development for each Board Director to ensure that we retain good governance standards. These include mandatory in-house and external trainings on a wide range of topics, including financial crime, cyder-security awareness, and regional and global macro-economic environment. Training also covers key trends in management of compliance and AML risks, as well as developments on ESG topics. Staff at SAB also receive ESG training, with selected internal ESG champions playing a facilitative role in creating awareness on ESG matters across the Bank. ",
    paragraphThree: "Managing risk is integral to sustainable value creation. We have a mature risk culture that is embedded throughout all our business units, enablement, and control functions. In recent years, we have refined our risk management framework so that it transparently reports our ESG risks.",
    // paragraphOne : "A robust approach to corporate governance is a key strength for any organisation. SABB ensures it adopts best practices in this field to create value for all the Bank’s stakeholders. Our governance approach exhibits a track record of strengths and achievements, including diversity, with our Board being a mixture of local and international experts from a wide spectrum of industries. In terms of gender diversity achievement, SABB is in the upper quartiles of organisations in the region. Our Executive Management team currently includes five females, and 22% of all our employees are women. SABB provides ongoing training and development for each Board Director to ensure that we retain good governance standards. SABB's bespoke training programme covers corporate governance best practices and mandatory training on topics such as financial crime, cybersecurity, regional and global macro-economic environment, key trends in management of compliance and AML risks, as well as developments on ESG topics. Staff at SABB also receive ESG training, with selected internal ESG champions playing a facilitative role in creating awareness on ESG matters across the Bank. Managing risk is equally important for driving value for our stakeholders. SABB has established a strong risk culture across the organisation, embedded throughout business units, enablement, and control functions. In recent years, we have refined our risk management framework so that it transparently reports our ESG risks",
    sectionOne: {
        title: "Focus Areas",
        cards: [
            {
                icon: "tree.svg",
                title: "Deploy ESG governance structure",
                subtitle: "Ensure structure adequately fits the Bank’s governance priorities",
            },
            {
                icon: "social-network.svg",
                title: "Embed ESG across SAB",
                subtitle: "ESG training and champions",
            },
            {
                icon: "news.svg",
                title: "Contribute to international standards",
                subtitle: "United Nations Principles for Responsible Banking (UNPRB)",
            },
            {
                icon: "bag.svg",
                title: "Bank governance framework",
                subtitle: "Risk management and compliance",
            },
        ]
    },
    sectionTwo: {
        title: "Governance structure",
        tableOne: {
            title: "Board structure and composition",
            table: {
                headers: ["Board of Directors’ composition", "2020", "2021", "2022"],
                data: [
                    {
                        element: "Percentage of Board of Directors’ seats occupied by women",
                        2020: "18%",
                        2021: "9%",
                        2022: "9%",
                    },
                    {
                        element: "Percentage of Board seats occupied by independent Directors (in line with regulatory requirements)",
                        2020: "36%",
                        2021: "36%",
                        2022: "36%",
                    },
                    {
                        element: "Executive members of the Board of Directors",
                        2020: "9%",
                        2021: "9%",
                        2022: "9%",
                    },
                    {
                        element: "Non-Executive members of the Board of Directors",
                        2020: "54%",
                        2021: "54%",
                        2022: "54%",
                    },
                    {
                        element: "Female members of the Board of Directors",
                        2020: "2",
                        2021: "1",
                        2022: "1",
                    },
                    {
                        element: "Male members of the Board of Directors",
                        2020: "9",
                        2021: "10",
                        2022: "10",
                    },
                    {
                        element: "Independent members of the Board of Directors",
                        2020: "4",
                        2021: "4",
                        2022: "4",
                    },
                    {
                        element: "Non-Executive members of the Board of Directors",
                        2020: "6",
                        2021: "6",
                        2022: "6",
                    },
                ]
            },
            paragraph: "The SAB Board sets the Bank’s strategy to achieve sustainable value for shareholders and promotes a culture of openness and debate. It also approves the capital and operating plans for achieving the Bank’s strategic direction, on the recommendation of the Executive Management (‘MANCOM’). The current Board comprises of 11 members, inclusive of 5 independent Directors. SAB is the first listed company in the Kingdom to appoint a female Chair to the Board."
        },
        tableTwo: {
            title: "Board and Management Committees",
            paragraph: "SAB Corporate Governance (CG) was mandated by the Board to evaluate the structure of SAB’s corporate governance Management Committees (MCs). After a re-evaluation that considered regulations and best practices, SAB’s 40 MCs were reduced to 24 committees focusing on economic, environmental, and social impacts. This has helped to streamline decision-making by reducing overlapping responsibilities, removing redundancies and clarifying objectives. All MC members have an ESG-related Key Performance Indicator (KPI) in their performance scorecard.",
            table: {
                head: "Board of Directors and its sub-committees",
                headers: [],
                data: [
                    [
                        "Executive Committee (EXCOM)",
                        "Audit Committee (AUCOM)",
                        "Board Risk Committee (BRC)",
                        "Nomination and Remuneration Committee (NRC)",
                        "Technology and Digital Committee (TechCom)",
                    ],
                    [
                        "The SAB Board of Directors established an Executive Committee to support it in the discharge of its responsibilities and the oversight of the Bank’s day-to-day operations and activities. This Committee meets at least 6 times during the year.",
                        "The Audit Committee was established to support the SAB Board with responsibilities such as supervising the Internal Audit function, reviewing internal controls and reporting systems, recommending the appointment of external Auditors and fixing of their fees, in addition to any other tasks assigned by the Board as provided for in the rules and regulations issued by the Supervisory Authorities. ",
                        "The BRC has oversight of enterprise risk management, risk governance, and internal control systems. It provides advice to the Board on the Bank’s emerging risks, risk appetite, and risk strategy",
                        "The NRC recommends the nominations for Board membership in line with SAB’s Selection Policy for Board and Board Committee members. It annually reviews the skills and capabilities required of those suitable for Board membership. This Committee also holistically evaluates the effectiveness of the Board members, its Committees, and the Board itself. ",
                        "The TechCom is responsible for assisting the Board in overseeing the execution of the Bank’s strategic plan, strategic objectives, and major initiatives with respect to information technology, digital technology, transformation, and innovation. This committee has been established in 2023.",
                    ]
                ]
            }
        }
    },
    sectionThree: {
        title: "2023 highlights in the repositioning of Corporate Governance",
        subtitle: "In 2023, the Board operated in a hybrid format, with in-person and video conference participation by directors and management. ESG was featured regularly in all the topics discussed. In particular, the Board and its committees addressed the following sustainability-related topics: SAB’s Consumer Protection Policy, SAB’s Whistleblowing Policy, SAB’s ESG Report, SAB’s Sanctions Policy. Additionally, an entire session on ESG-related topics gave the Board ample time to dive deep into the most pressing ESG-related issues",
        image: {
            alt: "",
            name: "governence-section-one.jpg"
        }
    },
    sectionFour: {
        title: "ESG Governance framework",
        paragraph: "During the reporting period under review, SAB implemented a new corporate governance framework. The Corporate Governance department, along with the Legal department, initiated work on responding to the bylaws that will be adopted in line with the new provisions of the Companies Law and its regulations issued in 2022. The Corporate Governance department also led a review of Board policies as well as Terms of Reference for Board Committees. The outcome is a streamlined governance framework that will support SAB’s ESG goals more effectively going forward.",
        borderBox: {
            title: "Environmental Social and Governance (ESG) Steering Committee",
            subtitle: "SAB established a Management-level ESG Steering Committee comprising of representatives of various business lines and functions. The Committee is responsible for providing oversight of all ESG-related matters and strategic objectives, including climate risk. It provides holistic governance, oversight, management, and coordination of all commitments within the approved ESG strategy. The Committee draws its authority from the Board EXCOM Committee and fulfils its delegated responsibilities within the Bank’s risk appetite and corporate governance framework. During 2022, SAB held its inaugural ESG Steering Committee meeting, chaired by SAB’s Managing Director, Tony Cripps.",
        },
        linedData: [
            <p>The ESG Steering Committee</p>,
            <p><b>Chair: </b>Managing Director </p>,
            <p><b>Secretary: </b>Senior Advisor - ESG</p>
        ],
        cardsOne: [
            {
                title: "Membership",
                subtitle: "Membership is determined by the Managing Director in consultation with the Company Secretary and currently includes:",
                list: [
                    "Managing Director (Chair)",
                    "Financial Officer ",
                    "Chief Risk Officer",
                    "Chief Operational Officer",
                    "Chief Corporate and Institutional Banking Officer",
                    "Chief Wealth and Personal Banking Officer",
                    "Chief Treasury Officer",
                    "Company Secretary",
                ],
            },
            {
                title: "Additional members",
                subtitle: "Permanent invitees to the Committee are:",
                list: [
                    "Chief Human Resource Officer",
                    "Chief Strategy Officer",
                    "Head of Corporate Communication and ESG",
                ]
            }
        ],
        borderBoxThree: {
            title: "Sustainable Finance governance",
            subtitle: "Operationally, sustainable finance is originated in our business divisions CIB, WPB, and Treasury. This origination is tied into the broader sustainable finance governance structure which consists of three layers"
        },
        borderBoxTwo: {
            title: "CIB Sustainable Finance Forum (CSFF)",
            subtitle: "The sustainable finance market is maturing, and SAB intends to expand its sustainable finance product suite with both use of proceeds and incentive-based structures (Sustainability Linked Finance) based on the market principles outlined below, to meet increasing client demand. To ensure proper governance of this process, SAB established the SAB CSFF to: "
        },
        listOne: [
            "Provide high level governance and oversight of SAB CIB’s sustainable finance proposition in order to ensure consistency of approach across CIB",
            "Provide endorsement to the business on the labelling of sustainable finance transactions",
            "Note updates on internal tracking of green, social or sustainable loan activity for relevant reporting"
        ],
        paragraphTwo: "CSFF Chair reports matters needing escalation, to the CIB Management Committee and or the SAB ESG Steering Committee if and when required. The CSFF reviews client transactions including corporate finance and trade finance, against well recognised market principles (by Loan Market Association, Asia Pacific Loan Market Association, Loan Syndications & Trading Association) such as:",
        cardsTwo: [
            {
                title: "Green loan principles",
                subtitle: " Clients need to prescribe to 4 pillars within this principle. The key pillar is that loans are made available to fully or partially finance/re-finance new or existing eligible green projects which can include but are not limited to renewable energy, green building, clean transportation, and pollution prevention amongst other categories.",
            },
            {
                title: "Social loan principles",
                subtitle: "These principles define a framework enabling clients to assess the outcome of their projects amongst the defined criteria’s. Social project criteria include but are not limited to impact of the project on people with disabilities, marginalised communities, migrants or displaced personas, unemployed, and women amongst other categories.",
            },
            {
                title: "Sustainability linked loan principles",
                subtitle: "These principles allow for clients to set up borrowing facilities which incentivises them to achieve ambitious, pre-determined sustainability performance targets. Since these loans are focused on clients looking to transition towards positive future outcomes, there are strict criteria on what category the KPIs can be set towards, which include but are not limited to energy efficiency, greenhouse gas emissions, renewable energy, human rights, data security and business ethics amongst others."
            }
        ],
        paragraphThree: "The CSFF meets as required to review sustainable finance transactions against prescribed market principles."
    },
    flexViewSection: [
        {
            image: {
                name: "img-2.jpg",
                alt: "Light Cross the trees",
            },
            title: "Social Impact",
            subtitle: "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
            button: {
                text: "Read More",
                path: pagesNames.home
            }
        },
        {
            image: {
                name: "img-5.jpg",
                alt: "a person using a laptop",
            },
            title: "Overarching Goal",
            subtitle: "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making.",
            button: {
                text: "Read More",
                path: pagesNames.home
            }
        },
        {
            image: {
                name: "img-4.jpg",
                alt: "A woman helps a child",
            },
            title: "Sustainability in Our Operations",
            subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim",
            button: {
                text: "Read More",
                path: pagesNames.home
            }
        },
    ]
};

export default governancePageData;